import React from 'react'
import NoDataImage1 from "../assets/images/No data-amico (1) 1.png"
import NoDataImage2 from "../assets/images/404.png"
const NoData = ({iamge = 1}) => {
  return <>
  <div className="row">
    <div className="col-md-12 d-flex justify-content-center">
        <img src={iamge === 1 ?  NoDataImage1 : NoDataImage2} alt="NoDataImage" />
    </div>
  </div>
  </>
}

export default NoData